import styled from 'styled-components';

export const modalContentStyle: React.CSSProperties = {
  height: 'calc(100vh - 112px)',
};

export const bodyModalDialogStyle: React.CSSProperties = {
  padding: 0,
  flexGrow: 1,
  height: 0,
  maxHeight: 'none',
  overflow: 'hidden',
};

export const tableStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
};

export const cardStyle: React.CSSProperties = {
  height: '100%',
};

export const tableContentStyle: React.CSSProperties = {
  height: '100%',
};

export const tableContainerStyle: React.CSSProperties = {
  flexGrow: 1,
  height: 0,
};

export const bodyStyle: React.CSSProperties = {
  flexGrow: 1,
  height: 0,
  overflow: 'auto',
};

export const BinDetailCardWrapper = styled.div<{
  isDraggedOverBin: boolean;
  isEmptyPosition: boolean;
}>`
  background: ${({ isDraggedOverBin, isEmptyPosition }) =>
    isEmptyPosition ? 'transparent' : isDraggedOverBin ? '#aed7ff' : '#fff'};
  border-radius: 8px;
  cursor: pointer;
  border: ${({ isEmptyPosition, isDraggedOverBin }) =>
    isEmptyPosition ? 'none' : isDraggedOverBin ? '1px solid var(--primary)' : '1px solid #d9d9d9'};
`;

export const RemoveExpiriedSensorModalTitle = styled.h3`
  font-weight: 400;
  font-size: 14px;
  line-height: calc(23 / 14);
  color: var(--neutral-10);
`;

export const CardInfo = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 8px 12px;
  background: var(--white);
  border: 1px solid #d9d9d9;
  cursor: pointer;
  border-radius: 8px;
  min-height: 92px;
  gap: 12px;
  flex-direction: column;
`;
